import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@lichtblick/logger';
import { ComboBox } from '@lichtblick/photon/molecules/combo-box';
import { useTracker } from '@lichtblick/tracker';
import { useCallback, useEffect, useState } from 'react';
export const fetchCities = async (zip)=>{
    let retryCount = 3;
    while(retryCount > 0){
        let response;
        try {
            response = await fetch(`/api/zip/${zip}/`);
        } catch (_e) {
        // handled via retryCounter
        }
        if (response?.status === 200) {
            try {
                return await response.json();
            } catch (error) {
                logger.warn('[AIOC] Failed parsing cities JSON', {
                    error,
                    zip
                });
            }
        }
        retryCount--;
        if (retryCount === 0) {
            logger.log('[AIOC] Failed to fetch cities');
        }
        await new Promise((resolve)=>setTimeout(resolve, 500));
    }
    return undefined;
};
const comboBoxCallback = async (searchValue)=>{
    try {
        const zip = searchValue.slice(0, 5).trim();
        if (!/^\d{5}/.test(zip)) {
            return 'Bitte gib eine PLZ mit 5 Ziffern ein';
        }
        const cities = await fetchCities(zip);
        if (cities === undefined) {
            return 'Unbekannter Fehler';
        }
        const results = cities.filter((city)=>{
            return city.label.toLowerCase().includes(searchValue.toLowerCase());
        });
        if (results.length === 0) {
            return 'Keine Treffer gefunden';
        }
        return results;
    } catch (error) {
        logger.warn('Failed to fetch cities', {
            error,
            searchValue
        });
        return 'Unbekannter Fehler';
    }
};
export const CityInput = ({ onChange, defaultZip })=>{
    const { trackCustomEvent } = useTracker();
    const [defaultCity, setDefaultCity] = useState();
    const handleChange = useCallback((option)=>{
        trackCustomEvent({
            eventName: 'tariff_calculator_interaction'
        }, undefined, true);
        const [zip, city] = option.value.split('|');
        onChange(city, zip);
    }, [
        onChange,
        trackCustomEvent
    ]);
    useEffect(()=>{
        if (defaultZip && /^\d{5}$/.test(defaultZip)) {
            fetchCities(defaultZip).then((cities)=>{
                const city = cities?.[0];
                if (city) {
                    setDefaultCity(city);
                    const [zip, cityName] = city.value.split('|');
                    onChange(cityName, zip);
                }
            });
        }
    }, [
        defaultZip,
        onChange
    ]);
    return /*#__PURE__*/ _jsx(ComboBox, {
        autoComplete: "postal-code",
        "data-testid": "combo-box-city",
        errorMessage: "Hier fehlt noch eine Angabe",
        inputMode: "numeric",
        label: "Postleitzahl, Ort",
        onChange: handleChange,
        optionsCallback: comboBoxCallback,
        hideLabelSuffix: true,
        required: true,
        searchPlaceholder: "Postleitzahl",
        defaultOption: defaultCity ? {
            label: defaultCity.label,
            value: defaultCity.value
        } : undefined,
        defaultSearchValue: defaultZip
    });
};

//# sourceMappingURL=CityInput.js.map